import store from "@src/reducers/store";
import { updateActiveMachineStructureNode } from "@src/reducers/your-reducer";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";

export const filterInitialStructureNew = (filterInputContent) => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const nodeManager = getNodeManager();
  nodeManager.closeInitialStructureFilterModal();

  nodeManager.writeFilterInputContentToStoreInInitialFilterModal(
    filterInputContent,
  );

  const initialStructureNodeset = getInitialStructureNodeset();

  initialStructureNodeset.filterNodes(filterInputContent);
  initialStructureNodeset.setShowFilterPanel(true);

  nodeManager.closeNodeManagerDetailsPanel();
  store.dispatch(updateActiveMachineStructureNode(""));

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(
    `Action to filter initial list with new structure took ${
      t1 - t0
    } milliseconds.`,
  );
};
